import { inject } from "vue";
import type { createStoreSingleton } from "@/store/createStore";

export const useStore = () => {
  const store = inject("store") as ReturnType<typeof createStoreSingleton>;

  return store;
};
